import { SWITCHOPTIONS } from 'common/domain/constants';
import { MODULE_ID as FOOD_BENEFIT_MODULE_ID} from 'food-benefit.module/common/domain/constants';
import { MODULE_ID as VACATIONS_ABSENCES_MODULE_ID} from 'vacations-absences.module/common/domain/constants';

class CreateDelegationHelpController {
  constructor($translate, $q) {
    'ngInject';
    this.translate = $translate;
    this.q = $q;

    this.texts = {};
    this._translate();
  }

  getHelpText() {
    if (this.isManager()) {
      return this.texts[this.module].manager;
    }
    return this.texts[this.module].user;
  }

  isUser() {
    return this.delegationType === SWITCHOPTIONS.USER;
  }

  isManager() {
    return this.delegationType === SWITCHOPTIONS.MANAGER;
  }

  _translate() {
    this.texts[FOOD_BENEFIT_MODULE_ID] = {
      user : '',
      manager : ''
    };
    this.texts[VACATIONS_ABSENCES_MODULE_ID] = {
      manager : ''
    };

    return this.q.all([
      this.translate('GLOBALS.DELEGATION_HELP.FOOD_BENEFIT.USER').then((translation) => {
        this.texts[FOOD_BENEFIT_MODULE_ID].user = translation;
      }),

      this.translate('GLOBALS.DELEGATION_HELP.FOOD_BENEFIT.MANAGER').then((translation) => {
        this.texts[FOOD_BENEFIT_MODULE_ID].manager = translation;
      }),

      this.translate('GLOBALS.DELEGATION_HELP.VACATIONS_ABSENCES.MANAGER').then((translation) => {
        this.texts[VACATIONS_ABSENCES_MODULE_ID].manager = translation;
      })
    ]);
  }
}

export default CreateDelegationHelpController;



// WEBPACK FOOTER //
// ./client/app/components/modalDelegationManager/modalCreateDelegation/createDelegationHelp/createDelegationHelp.controller.js